import Cookies from "universal-cookie";

const cookies = new Cookies();
export default class Global {
   static user: any = {};
   static isAdmin = false;
   static token = "";
   static cities = [];
   static API_URL = "https://mediflow-server-service.onrender.com";

   static getUser = async () => {
      try {
         const data = await this.httpGET("auth/me");
         if (!data.isError && data.user) {
            this.isAdmin = data.isAdmin;
            this.user = data.user;
            return data.user;
         }
      } catch (err) {
         console.log("[get user] error - ", err);
         alert("Something went wrong.");
         return false;
      }
   };

   static checkSession = async () => {
      console.log(cookies.get("token"));
      if (cookies.get("token")) {
         //check token in cookies
         Global.token = cookies.get("token");
         const user = await Global.getUser();
         console.log({ user });
         if (!user) {
            this.token = "";
            this.user = {};
            this.isAdmin = false;
            cookies.remove("token");
            return false;
         } else {
            return user;
         }
      } else {
         return false;
      }
   };

   static httpGET(endpoint: string): Promise<any> {
      return new Promise<any>(async (resolve, reject) => {
         try {
            console.log("httpGET", endpoint);

            let output: any = await fetch(`${this.API_URL}/${endpoint}`, {
               method: "GET",
               headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + this.token,
               },
            });
            let statusCode = output.status;
            if (statusCode !== 200) {
            }
            try {
               output = await output.json();
               if (output.isError && output.error) {
                  alert(output.error);
                  resolve(null);
               } else {
                  resolve(output);
               }
            } catch (err) {
               console.error(endpoint, err);
               resolve(null);
            }
         } catch (err) {
            console.error(endpoint, err);
            resolve(null);
         }
      });
   }
   static httpPost(endpoint: string, data: any): Promise<any> {
      return new Promise<any>(async (resolve, reject) => {
         try {
            console.log("httpPost", endpoint);

            let output: any = await fetch(`${this.API_URL}/${endpoint}`, {
               method: "POST",
               headers: {
                  "Content-Type": "application/json",
                  Authorization: "Bearer " + this.token,
               },
               body: JSON.stringify(data),
            });
            let statusCode = output.status;
            if (statusCode !== 200) {
            }
            try {
               output = await output.json();
               if (output.isError && output.error) {
                  alert(output.error);
                  resolve(null);
               } else {
                  resolve(output);
               }
            } catch (err) {
               console.error(endpoint, data, err);
               resolve(output);
            }
         } catch (err) {
            console.error(endpoint, err);
            resolve(null);
         }
      });
   }
}
